import {
	Directive,
	ElementRef,
	Input,
	OnChanges,
	OnInit,
	Renderer2
} from '@angular/core';

@Directive({
	selector: '[spinning-wheel]'
})
export class SpinningWheelComponent implements OnChanges, OnInit {
	@Input('is-spinning-wheel-active') isSpinningWheelActive: boolean;
	@Input('is-spinning-wheel-after') isSpinningWheelAfter: string;
	@Input('is-spinning-wheel-dark') isSpinningWheelDark: string;

	constructor(private renderer: Renderer2, private el: ElementRef) {
		this.renderer.addClass(this.el.nativeElement, 'wild');
	}

	ngOnInit() {
		const el = this.el.nativeElement;
		this.renderer.addClass(el, 'spinning-wheel');

		if (this.isSpinningWheelAfter === 'true') {
			this.renderer.addClass(el, 'spinning-wheel__display-after');
		} else {
			this.renderer.addClass(el, 'spinning-wheel__display-before');
		}

		if (this.isSpinningWheelDark === 'true') {
			this.renderer.addClass(el, 'spinning-wheel__dark');
		}
	}

	ngOnChanges() {
		const el = this.el.nativeElement;
		if (this.isSpinningWheelActive === true) {
			this.renderer.addClass(el, 'spinning-wheel__active');
		} else {
			this.renderer.removeClass(el, 'spinning-wheel__active');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/spinning-wheel/spinning-wheel.ts